<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<app-header-card [title]="'All Tournaments'">
  <button mat-flat-button color="primary">
    <a [routerLink]="'/admin/tournaments/create'" class="no-decoration">Create Tournament</a>
  </button>
</app-header-card>

<div class="tournaments-list">
  @for (tournament of getTournaments(); track tournament.id) {
    <app-tournament-card
      [tournament]="tournament"
      (tournamentDeleted)="onTournamentDeleted()"
      data-cy="tournaments-list"
    ></app-tournament-card>
  }
</div>

@if (getTournaments().length === 0) {
  <div class="no-matches-container">
    <h1>Its empty here 🧹</h1>
    <h2>You have not created any tournaments yet.</h2>
    <button mat-flat-button [routerLink]="'/admin/tournaments/create'" [color]="'primary'">
      <mat-icon>design_services</mat-icon>
      Create your first tournament
    </button>
  </div>
}
